<template>
  <div>
    <div
      class="instruction_title text-left para-mrgn-20"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedBody`,
        val: lang,
        html: question.formattedBody
      }"
      v-html="question.formattedBody"
    />
    <div class="col-md-1 mt-25 med-back" v-if="isMedecineSelected">
      <svg @click="backbutton" xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="none" viewBox="0 0 15 25">
        <path fill="var(--primary)" fill-rule="evenodd" d="M14.773 2.344L12.43 0 0 12.43l12.43 12.43 2.343-2.345L4.688 12.43 14.773 2.344z" clip-rule="evenodd" />
      </svg>
    </div>
    <div v-if="isMedecineSelected === false && !showManualmedication">
      <div class="row mt-25" v-for="(v, i) in options" :key="i">
        <div class="col-md-12">
          <ul class="list-group list-group-flush d-block border">
            <b class="med-heading">{{ i }}</b>
            <li class="list-group-item pt-5 pb-5 dose_name" v-for="(c, ci) in v" :key="ci" @click="selectMedicine(c)">
              {{ c.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-inline-block mt-25 col-md-10 med-selector-wrap" v-if="dosage && isMedecineSelected" @click.once="$emit('onClick', question)">
      <h5 class="text-center">{{ selectedOption.name }}</h5>
      <div class="dosage">
        <div
          class="border p-10 medicine"
          :class="{
            active: selectedOption && selectedOption.medicationDosage === d
          }"
          v-for="(d, i) in removeDupilicatedDosages(dosage)"
          :key="i"
          @click="selectDosage(d, i)"
        >
          {{ isNewMedicationActivity ? d + dosageUnits[i] : d }}
        </div>

        <div v-if="componentData.isAllowOtherDosage" class="border p-10 medicine" :class="{ active: isOtherDosageSelected }" v-translate:ethnicity_other="lang" @click="selectDosage('other', 0)">
          Other
        </div>
      </div>
      <div class="form-group mt-20">
        <input v-if="componentData.isAllowOtherDosage && isOtherDosageSelected" v-model="selectedOption.medicationDosage" class="form-control mb-15" type="text" @change="onAnswerChange" @keydown="checkCharacter($event)" placeholder="Enter in dosage amount" />
        <div v-if="isNewMedicationActivity && componentData.isAllowOtherDosage && isOtherDosageSelected && question.constraints.dosageUnits && question.constraints.dosageUnits.length">
          <select @change="onAnswerChange" class="mb-15 form-control floating-select" id="unit-select" v-model="selectedOption.dosageUnits" style="height:56px" value="">
            <option value="" disabled selected>Select dosage unit</option>
            <option v-for="(unit, i) in question.constraints.dosageUnits" :key="i" :value="unit">{{ unit }}</option>
          </select>
        </div>
        <div v-else-if="isNewMedicationActivity && componentData.isAllowOtherDosage && isOtherDosageSelected && !question.constraints.dosageUnits.length">
          <input v-model="selectedOption.dosageUnits" class="form-control mb-15" type="number" @change="onAnswerChange" placeholder="Enter a dosage unit" />
        </div>
        <div v-if="!isNewMedicationActivity && componentData.isAllowOtherDosage && isOtherDosageSelected">
          <input v-model="selectedOption.dosageUnits" class="form-control mb-15" type="text" @change="onAnswerChange" placeholder="Enter a dosage unit" />
        </div>

        <input v-model="selectedOption.numberOfDoses" class="form-control mb-15" type="number" @change="onAnswerChange" placeholder="Enter number of doses" />
        <div v-if="question.constraints.reasons && question.constraints.reasons.length">
          <select class="mb-15 form-control floating-select" id="unit-select" v-model="selectedOption.reasons" style="height:56px" value="" @change="clearInput(selectedOption.reasons)">
            <option value="" disabled selected>Select reason of use</option>
            <option v-for="(reason, i) in question.constraints.reasons" :key="i" :value="reason">{{ reason }}</option>
            <option value="Other reason" v-if="question.constraints.addOtherReason">Other reason</option>
          </select>
        </div>
        <input v-if="selectedOption.reasons == 'Other reason'" v-model="selectedOption.otherReasons" class="form-control mb-15" type="text" placeholder="Enter other reason" @change="onAnswerChange" />
      </div>
      <div class="text-center">
        <button class="fs-14 btn btn-submit" @click="addNewMedication()" v-translate:btn_medication_selector_add="lang">
          Add another medication
        </button>
      </div>
    </div>
    <div v-if="isMedecineSelected === false">
      <div v-if="showManualmedication">
        <h4>Provide your medication information below.</h4>
        <div class="form-group mt-20">
          <input v-model="selectedOption.medicationName" class="form-control mb-15" type="text" @change="onAnswerChange" placeholder="Enter the generic or brand name" />
          <input v-model="selectedOption.medicationDosage" class="form-control mb-15" type="text" @change="onAnswerChange" @keydown="checkCharacter($event)" placeholder="Enter in dosage amount" />
          <div v-if="question.constraints.dosageUnits && question.constraints.dosageUnits.length">
            <select @change="onAnswerChange" class="mb-15 form-control floating-select" id="unit-select" v-model="selectedOption.dosageUnits" style="height:56px" value="">
              <option value="" disabled selected>Select dosage unit</option>
              <option v-for="(unit, i) in question.constraints.dosageUnits" :key="i" :value="unit">{{ unit }}</option>
            </select>
          </div>

          <div v-else>
            <input v-model="selectedOption.dosageUnits" class="form-control mb-15" type="text" @change="onAnswerChange" placeholder="Enter a dosage unit" />
          </div>
          <input v-model="selectedOption.numberOfDoses" class="form-control mb-15" type="number" @change="onAnswerChange" placeholder="Enter number of doses" />
          <div v-if="question.constraints.reasons && question.constraints.reasons.length">
            <select class="mb-15 form-control floating-select" id="unit-select" v-model="selectedOption.reasons" style="height:56px" value="" @change="clearInput(selectedOption.reasons)">
              <option value="" disabled selected>Select reason of use</option>
              <option v-for="(reason, i) in question.constraints.reasons" :key="i" :value="reason">{{ reason }}</option>
              <option value="Other reason" v-if="question.constraints.addOtherReason">Other reason</option>
            </select>
            <input v-if="selectedOption.reasons == 'Other reason'" v-model="selectedOption.otherReasons" class="form-control mb-15" type="text" placeholder="Enter other reason" @change="onAnswerChange" />
          </div>
        </div>
      </div>
      <div style="text-align:center">
        <a
          v-if="!showManualmedication"
          style="cursor:pointer; color:red;"
          class="fs-14"
          @click="
            clearMedicineInput();
            (showManualmedication = true), (selectedOption.isNonCSV = true), (selectedOption.isOtherSelected = true);
          "
          >I don't see my medication on the list</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "med-selector",
  mixins: [langTranslate],
  data() {
    return {
      options: {},
      dosage: {},
      selectedOptions: [],
      selectedOption: {
        isOtherSelected: false,
        listImages: [],
        medicationType: "",
        medicationName: "",
        medicationDosage: "",
        medicationDosageQuantity: null,
        prevPosition: 0,
        dosageUnits: "",
        numberOfDoses: "",
        reasons: "",
        otherReasons: "",
        isNonCSV: false,
        isNewActivity: true
      },
      optionDosages: null,
      isMedecineSelected: false,
      isOtherDosageSelected: false,
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {},
      dosageUnits: "",
      showManualmedication: false,
      isNewMedicationActivity: true,
      dosageFlag: ""
    };
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  mounted() {
    this.createOptions();
    this.checkIfMedicationIsLegacy();
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  methods: {
    createOptions() {
      const options = {};
      if (this.question.constraints && this.question.constraints.content && this.question.constraints.content[0]) {
        for (let i = 0; i < this.question.constraints.content[0].options.length; i++) {
          const e = this.question.constraints.content[0].options[i];
          if (Object.keys(options).includes(e.category)) {
            options[e.category].push({
              category: e.category,
              name: e.name,
              dosage: e.dosage,
              dosageUnits: e.dosageUnits
            });
          } else {
            options[e.category] = [
              {
                category: e.category,
                name: e.name,
                dosage: e.dosage,
                dosageUnits: e.dosageUnits
              }
            ];
          }
        }
        this.options = options;
      }
    },
    checkIfMedicationIsLegacy() {
      if (!this.question.constraints.reasons || this.question.constraints.reasons == null) {
        this.isNewMedicationActivity = false;
        this.selectedOption.isNewActivity = false;
      } else {
        if (this.question.constraints && this.question.constraints.content > 0 && this.question.constraints.content.length > 0 && this.question.constraints.content[0]["options"].dosageUnits == null) {
          this.isNewMedicationActivity = false;
          this.selectedOption.isNewActivity = false;
        }
      }
    },
    selectMedicine(medicine) {
      this.clearMedicineInput();
      this.isMedecineSelected = true;
      this.dosage = medicine.dosage;
      if (medicine.dosageUnits != undefined) {
        this.dosageUnits = medicine.dosageUnits;
        this.isNewMedicationActivity = true;
        this.selectedOption.isNewActivity = true;
      } else {
        this.isNewMedicationActivity = false;
        this.selectedOption.isNewActivity = false;
      }

      this.selectedOption["medicationType"] = medicine.category;
      this.selectedOption["medicationName"] = medicine.name;
      this.onAnswerChange();
    },
    clearMedicineInput() {
      this.selectedOption = {
        isOtherSelected: false,
        listImages: [],
        medicationType: "",
        medicationName: "",
        medicationDosage: "",
        medicationDosageQuantity: null,
        prevPosition: 0,
        dosageUnits: "",
        numberOfDoses: "",
        reasons: "",
        otherReasons: "",
        isNonCSV: false,
        isNewActivity: true
      };
      this.checkIfMedicationIsLegacy();
    },
    selectDosage(dosage, i) {
      if (dosage !== "other") {
        if (this.dosageFlag == "other") {
          this.clearMedicationDosageItems();
        }
        this.dosageFlag = "medicine";
        this.selectedOption["medicationDosage"] = dosage;
        if (this.isNewMedicationActivity && this.dosageUnits[i]) {
          this.selectedOption["dosageUnits"] = this.dosageUnits[i];
        }
        this.isOtherDosageSelected = false;
        this.selectedOption["isOtherSelected"] = false;
      } else {
        if (this.dosageFlag == "medicine") {
          this.clearMedicationDosageItems();
        }
        this.dosageFlag = "other";
        this.selectedOption["medicationDosage"] = null;
        this.selectedOption["isOtherSelected"] = true;
        this.isOtherDosageSelected = true;
      }
      this.onAnswerChange();
    },
    backbutton() {
      this.isMedecineSelected = false;
    },
    addNewMedication() {
      this.selectedOptions.push(this.selectedOption);
      this.isMedecineSelected = false;
      this.isOtherDosageSelected = false;
      this.selectedOption["isOtherSelected"] = false;
      this.selectedOption = {
        isOtherSelected: false,
        listImages: [],
        medicationType: "",
        medicationName: "",
        medicationDosage: "",
        otherDosage: "",
        medicationDosageQuantity: null,
        prevPosition: 0,
        dosageUnits: "",
        numberOfDoses: "",
        reasons: "",
        otherReasons: ""
      };
    },
    clearInput(reason) {
      if (reason != "Other reason") {
        this.selectedOption.otherReasons = "";
      }
      this.onAnswerChange();
    },
    onAnswerChange(e) {
      this.$nextTick(() => {
        this.onChangeOptions(e);
        this.question["medication"] = this.selectedOptions.length == 0 ? [this.selectedOption] : this.selectedOptions;
        this.$emit("onAnswerChange", this.question);
      });
    },
    onChangeOptions(e) {
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
    },
    removeDupilicatedDosages(dosages) {
      return dosages.reduce((firstValue, secondValue) => {
        if (firstValue.indexOf(secondValue) < 0) {
          firstValue.push(secondValue);
        }
        return firstValue;
      }, []);
    },
    clearMedicationDosageItems() {
      this.selectedOption["dosageUnits"] = "";
      this.selectedOption["numberOfDoses"] = "";
      this.selectedOption["otherReasons"] = "";
      this.selectedOption["reasons"] = "";
    },
    checkCharacter(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 47 && charCode !== 191 && charCode !== 46 && charCode !== 8 && charCode !== 37 && charCode !== 39 && charCode !== 190) {
        event.preventDefault();
      }
      const val = event.target.value;
      const hasInvalidCharacters = val.match(/[^0-9/]/);
      if (!hasInvalidCharacters) {
        return;
      }
      this.selectedOption["medicationDosage"] = val.replace(/[^0-9/.]/g, "");
    },
    clearAnswer(){
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.clearMedicationDosageItems();
    }
  }
};
</script>

<style>
.accordion {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
}

.med-selector-wrap .active,
.accordion:hover {
  background-color: #ccc;
}

.med-selector-wrap .active {
  background-color: #f8f8f8;
}

.open {
  display: block !important;
}

.panel,
.options {
  padding: 0 18px;
  display: none;
  background-color: white;
  overflow: hidden;
}
</style>
